var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    transform: "translate(0 -.087)",
    fill: "#4a4a4a",
    d: "M0 0h14v14H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .087)",
    clipPath: "url(#a)",
    fill: "#4a4a4a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M6.956 4.058a.435.435 0 01.435.435v2.609a.435.435 0 11-.87 0V4.493a.435.435 0 01.435-.435zm.58 5.217a.58.58 0 11-.58-.58.58.58 0 01.58.58z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M6.957.58a6.377 6.377 0 106.377 6.377A6.377 6.377 0 006.957.58zM1.45 6.957a5.507 5.507 0 115.507 5.507 5.507 5.507 0 01-5.508-5.507z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue);
export default __webpack_public_path__ + "static/media/issue.713b8e2d.svg";
export { ForwardRef as ReactComponent };